<template>
    <section
        ref="section21"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="24"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >

            <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
                <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
                    <div><v-icon icon="fireplace" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 mr-6 text-heading-3-desktop">
                            Katera je bistvena vrsta ogrevanja?
                        </div>
                        <div class="text-body-regular text-black-40">
                            Izberete lahko več možnosti.
                        </div>
                    </div>

                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Vrsta ogrevanja
                            </p>
                            <p class="mb-8 text-body-regular">
                                Pri opisu vrste ogrevanja je bistven način, kako se prostori ogrevajo in ne energenti, ki se uporabljajo za ogrevanje.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Etažno ogrevanje
                            </p>
                            <p class="mb-8 text-body-regular">
                                Pomeni, da ima nepremičnina na vsaki posamezni etaži napravo za ogrevanje.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Ogrevanje s pečjo
                            </p>
                            <p class="mb-8 text-body-regular">
                                Pomeni, da se nepremičnina ogreva s pečjo (npr. les ali elektrika).
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Centralno ogrevanje
                            </p>
                            <p class="mb-8 text-body-regular">
                                Center centralnega ogrevanja je peč, ki je običajno v kurilnici. S cevmi je povezana z radiatorji v hiši ali stanovanju, neodvisno od bistvenega vira energije.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Talno ogrevanje
                            </p>
                            <p class="mb-8 text-body-regular">
                                Je površinsko ogrevanje, ki ogreva prostore s pomočjo cevi, položenih v tla, neodvisno od bistvenega vira energije.
                            </p>

                            <p class="mb-[10px] text-icon-text-medium">
                                Daljinsko ogrevanje
                            </p>
                            <p class="mb-8 text-body-regular">
                                Je način ogrevanja stavb, pri katerem toploto prenašamo od večjega vira toplote k porabnikom po cevnem omrežju.
                            </p>

                        </template>
                    </v-lightbox>
                </figure>
                <figure class="ml-auto mr-auto w-full max-w-lg">
                    <form method="POST" :action="routes.submitForm" id="select-heating-type">
                        <v-csrf-token></v-csrf-token>
                        <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-4">
                            <li
                                class="col-span-4"
                                v-for="(
                                    heatingType, onOfficeEnum
                                ) in stepData.heizungsart_options"
                                :key="'heating-type-' + onOfficeEnum"
                            >
                                <v-checkbox
                                    checkbox-position="right"
                                    :id="onOfficeEnum"
                                    :name="'heizungsart[' + onOfficeEnum + ']'"
                                    :value="onOfficeEnum"
                                    :icon="heatingType.icon"
                                    :checked="
                                        stepData.heizungsart != null &&
                                        stepData.heizungsart[onOfficeEnum]
                                    "
                                    :label="
                                        stepData.labels.heizungsart.values[
                                            onOfficeEnum
                                        ]
                                    "
                                    :class="[
                                        'checkbox group flex items-center',
                                        validationErrors.heizungsart
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                ></v-checkbox>
                            </li>
                        </ul>
                    </form>
                </figure>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-heating-type')"
                class="button button--md h-[48px] w-[240px] px-6"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },

    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },

    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
